import { useCallback } from "react";
import { RichTextField as BaseRichTextField } from "@/components/RichTextField";
import { buildFilesUrl, filesService } from "@/api/profiles";

type BaseProps = Parameters<typeof BaseRichTextField>[0];
type Props = Omit<BaseProps, "uploadImage">;

/**
 * The shared `RichTextField` with the Profiles file store wired into its image
 * picker. Profiles forms use this; anything outside Profiles uses the component
 * in `@/components/RichTextField` with its own uploader.
 */
export function RichTextField(props: Props) {
  const uploadImage = useCallback(async (file: File) => {
    const { hash, filename } = await filesService.upload(file);
    const url = buildFilesUrl({ hash, filename });
    if (!url) throw new Error("Could not build the image URL. Please try again.");
    return { id: hash, url };
  }, []);

  return <BaseRichTextField {...props} uploadImage={uploadImage} />;
}
